import {
  OR_REQUEST_INIT_REGISTRATION_DATA,
  OR_RECEIVE_INIT_REGISTRATION_DATA,
  OR_RECEIVE_INIT_REGISTRATION_DATA_ERROR,
  OR_TOGGLE_CANCEL_REGISTRATION_MODAL,
  OR_REGISTRATION_RESET_DATA,
} from '../../actions/registration/ordersReservedRegistration';

export const initialState = {
  activeAddresses: [],
  smsNumber: null,
  smsEnabled: false,
  isFetchingInitData: false,
  isInitDataError: false,
  alreadySubscribed: false,
  cancelModalVisible: false,
};

export default function initDataReducer(state = initialState, action) {
  switch (action.type) {
    case OR_REQUEST_INIT_REGISTRATION_DATA:
      return {
        ...state,
        isFetchingInitData: true,
        cancelModalVisible: false,
      };
    case OR_RECEIVE_INIT_REGISTRATION_DATA:
      return {
        ...state,
        ...action.data,
        isFetchingInitData: false,
        isInitDataError: false,
      };
    case OR_RECEIVE_INIT_REGISTRATION_DATA_ERROR:
      return {
        ...state,
        isFetchingInitData: false,
        isInitDataError: true,
      };
    case OR_TOGGLE_CANCEL_REGISTRATION_MODAL:
      return { ...state, cancelModalVisible: !state.cancelModalVisible };
    case OR_REGISTRATION_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
